// import { SET_INVOICE_SUMMARY, CLEAR_INVOICE_SUMMARY } from "../types";

import { CLEAR_INVOICE_SUMMARY, SET_INVOICE_SUMMARY } from "../types";

const initialState = {
  invoiceSummary: null,
};

export const invoiceSummaryReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case SET_INVOICE_SUMMARY:
      return {
        ...state,
        invoiceSummary: action.payload,
      };
    case CLEAR_INVOICE_SUMMARY:
      return {
        ...state,
        invoiceSummary: null,
      };
    default:
      return state;
  }
};
